import { Theme } from '@salecycle/ui-component-library';
import { IconKey } from '@salecycle/ui-component-library/SvgIcons/svgIconsParams';
import styled, { css } from 'styled-components';

export type AlertVariant = 'info' | 'warning' | 'error' | 'success';

export const variationToColour = (theme: Theme) => ({
  info: theme.designToken.primary700,
  success: theme.designToken.success500,
  warning: theme.designToken.warning500,
  error: theme.designToken.error500,
});

export const variationToIcon: { [key: string]: IconKey } = {
  info: 'circle-info',
  success: 'check',
  warning: 'triangle-exclamation',
  error: 'ban',
};

export const Wrapper = styled.div<{ minWidth: string; headingOnly: boolean }>`
  background: ${({ theme }) => theme.designToken.baseWhite};
  min-height: ${({ headingOnly }) => (headingOnly ? 64 : 104)}px;
  min-width: ${({ minWidth }) => minWidth};
  width: 100%;
  padding: ${({ theme, headingOnly }) =>
    headingOnly ? `${theme.designToken.spacing3} ${theme.designToken.spacing4}` : theme.designToken.spacing4};
  border: 1px solid ${({ theme }) => theme.designToken.neutral300};
  position: relative;
  word-break: break-word;
  ${({ headingOnly }) => {
    if (headingOnly) {
      return css`
        display: flex;
        align-items: center;
      `;
    }
  }}
`;

export const BorderLeft = styled.div<{ variant: AlertVariant; headingOnly: boolean }>`
  position: absolute;
  width: 4px;
  height: calc(100% + 2px);
  background-color: ${({ theme, variant }) => variationToColour(theme)[variant]};
  margin: calc(
      -${({ theme, headingOnly }) => (headingOnly ? theme.designToken.spacing3 : theme.designToken.spacing4)} - 1px
    )
    calc(-${({ theme }) => theme.designToken.spacing4} - 1px);
`;

export const Content = styled.div<{ headingOnly: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeadingWrapper = styled.div<{ headingOnly: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.designToken.spacing3};
  width: 100%;
  ${({ headingOnly }) => {
    if (headingOnly) {
      return css`
        display: flex;
        align-items: center;
      `;
    }
  }}
`;

export const IconBackground = styled.div<{ variant: AlertVariant }>`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.designToken.spacing1};
  border-radius: ${({ theme }) => theme.designToken.borderRadius4};
  background-color: ${({ theme, variant }) => variationToColour(theme)[variant]};
  color: ${({ theme }) => theme.designToken.baseWhite};
`;

export const TitleDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Description = styled.div<{ collapsible?: boolean }>`
  font: ${({ theme }) => theme.designToken.body2};
  color: ${({ theme }) => theme.designToken.neutral700};
  margin-left: calc(32px + ${({ theme }) => theme.designToken.spacing3});
  max-height: calc(${({ theme }) => theme.designToken.spacing10} * 3);
  overflow-y: auto;
  ${({ collapsible, theme }) => {
    if (collapsible) {
      return css`
        margin-top: ${({ theme }) => theme.designToken.spacing3};
      `;
    }
  }};
`;

export const HeadingOnlyHeading = styled.p`
  margin: 0;
  font: ${({ theme }) => theme.designToken.body2};
`;
